export const METRIKA_ID = 104968477;

declare global {
  interface Window {
    ym?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export function injectMetrika() {
  if (typeof window === "undefined" || window.ym) return;

  (function (m: any, e: Document, t: string, r: string, i: string) {
    // создаём ym-функцию, если её ещё нет
    m[i] =
      m[i] ||
      function (...args: any[]) {
        (m[i].a = m[i].a || []).push(args);
      };

    m[i].l = Date.now();

    // защита от повторной вставки
    for (let j = 0; j < e.scripts.length; j++) {
      if ((e.scripts[j] as HTMLScriptElement).src === r) return;
    }

    const k = e.createElement(t) as HTMLScriptElement;
    const firstScript = e.getElementsByTagName(t)[0];
    k.async = true;
    k.src = r;

    (firstScript?.parentNode || e.head || e.documentElement).insertBefore(
      k,
      firstScript || null
    );
  })(
    window,
    document,
    "script",
    `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`,
    "ym"
  );

  window.ym!(METRIKA_ID, "init", {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: "dataLayer",
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

export function hit(url: string) {
  if (typeof window === "undefined" || !window.ym) return;
  window.ym(METRIKA_ID, "hit", url);
}
